module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/poi-94c091842a5309fbb2741d6cc0b03f9a.svg";